<template>
    <v-container fluid>
        <ChangeModulStatusDialog />
        <v-row>
            <v-col 
                class="headline" 
                cols="11"
                :alvqa="alvqa + '-title'"
            >
                {{ $t('lang_ACCOUNT_MODULES')}}
            </v-col>
        </v-row>
        <v-expansion-panels multiple>
            <SvWorkRegistrationModulePanel 
                :headers="headers" 
                :openChangeStatusDialogFunction="openChangeStatusDialog"
            />
            <CwrExportModulePanel 
                :headers="headers" 
                :openChangeStatusDialogFunction="openChangeStatusDialog"
            />
            <NdaSupportModulePanel 
                :headers="headers" 
                :openChangeStatusDialogFunction="openChangeStatusDialog"
            />
            <AlvVaultModulePanel 
                :headers="headers" 
                :openChangeStatusDialogFunction="openChangeStatusDialog"
            />
            <DigitalDistributionModulePanel 
                :headers="headers" 
                :openChangeStatusDialogFunction="openChangeStatusDialog"
            />
        </v-expansion-panels>
    </v-container>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import ChangeModulStatusDialog from './_dialogs/ChangeModulStatusDialog'

import SvWorkRegistrationModulePanel from './_panels/SvWorkRegistrationModulePanel'
import CwrExportModulePanel from './_panels/CwrExportModulePanel'
import NdaSupportModulePanel from './_panels/NdaSupportModulePanel'
import AlvVaultModulePanel from './_panels/AlvVaultModulePanel'
import DigitalDistributionModulePanel from './_panels/DigitalDistributionModulePanel'

export default {
    name: "Modules",
    components: {
        BasePanel,
        ChangeModulStatusDialog,
        SvWorkRegistrationModulePanel,
        CwrExportModulePanel,
        NdaSupportModulePanel,
        AlvVaultModulePanel,
        DigitalDistributionModulePanel
    },
    data() {
        return {
            alvqa: "account-modules"
        }
    },
    computed: { 
        headers() {
            return [
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_STATUS"),
                    value: "status", 
                    align: "left", 
                    class: 'text-no-wrap',
                    width: '180px',
                    alvqa: this.alvqa + "-header-status"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_PRICE") + ' EUR', // fixed currency as we invoice all users in EUR only
                    value: "price", 
                    align: "right", 
                    class: 'text-no-wrap',
                    width: "250px",
                    alvqa: this.alvqa + "-header-price"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_PATRONAGE"),
                    value: "patronage", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-patronage"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_PAYMENT_CYCLE"),
                    value: "paymentCycle", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-payment-cycle"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_BOOKED_ON"),
                    value: "bookedOn", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-booked-on"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_MINIMUM_PERIOD"),
                    value: "minimumPeriod", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-minimum-period"
                },
                {
                    text: this.$t("lang_ACCOUNT_MODULES_CAPTION_INFORMATION"),
                    value: "link", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-information"
                },
            ]
        }
    },
    methods: {
        openChangeStatusDialog(item) {
            if(item.status === true) {
                if(item.moduleName === 'digital-distribution') this.$store.commit('setChangeModulStatusDialogText', 'lang_SETTINGS_MODULES_APPLY_NOW_DIALOG_TEXT')
                else this.$store.commit('setChangeModulStatusDialogText', 'lang_SETTINGS_MODULES_CONFIRM_ACTIVATION')
            }
            else this.$store.commit('setChangeModulStatusDialogText', 'lang_SETTINGS_MODULES_CONFIRM_DEACTIVATION')
            
            // needs to be set so that the dialog is able to change the status back if user clicks cancel/no
            this.$store.commit('setSelectedModul', item)
            this.$store.commit('setShowChangeModulStatusDialog', true)
        },
    },
    created() {
        this.$store.dispatch('fetchModulesPanels')
    }
}
</script>